import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app">
      <header className="header">
        <div className="logo">
          <img src="/Lanza-Digital-06.png" alt="Lanza Digital Logo" className="logo-image" />
        </div>
      </header>
      <section className="hero">
        <h1>O que podemos fazer pela sua <span className="highlight">MARCA</span>?</h1>
        <div className="hero-content">
          <div className="hero-left">
            <img src="/avt2.png" alt="Rocket Icon" className="rocket-icon-image" />
          </div>
          <div className="hero-right">
            <h2>Marketing 360° que faz sua empresa <span className="highlight">DECOLAR</span></h2>
          </div>
        </div>
      </section>
      <section className="services">
        <ul className="services-list">
          <li>Criação de site</li>
          <li>Social Media</li>
          <li>Tráfego Pago</li>
          <li>Identidade Visual</li>
        </ul>
      </section>
      <section className="about">
        <h2>Sobre Nós</h2>
        <p>Somos especialistas em estratégias de social media, focando em reels e carrosséis para profissionais autônomos que criam conteúdo mas se sentem perdidos. Adaptamos conteúdo de experts para o nicho de estrategistas de social media, oferecendo consultoria personalizada para impulsionar sua presença online.</p>
      </section>
      <footer className="footer">
        <p>&copy; 2026 Lanza Digital. Todos os direitos reservados.</p>
      </footer>
    </div>
  );
}

export default App;